import { Button } from "@/components/buttons/button";

export function MainGreenButton({ children, onClick, className, disabled }: { children: React.ReactNode, onClick: () => void, className?: string, disabled?: boolean }) {
    return <Button className={`bg-light-green/01 text-black bg-light-green/01 hover:bg-light-green/01 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1.00)] transition-shadow duration-200 ${className}`} onClick={onClick} disabled={disabled}>
        {children}
    </Button>
}